import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';

export const StyledFormItem = styled(Flex)`
  ${({ disabled }) =>
    disabled
      ? `
    opacity: 0.6;
    pointer-events: none;
`
      : ''}
`;
